import type { NamedFieldProps } from "./Field.js";
import type { FormEventHandler } from "react";
import { NumberSchema, OptionalSchema, type ValueCallback, getNumber, getOptionalNumber, getSource } from "shelving";
import { Field, useField } from "./Field.js";
import { FieldNotice } from "./FieldNotice.js";

export function RangeField(props: NamedFieldProps): React.ReactElement {
	const field = useField(props);
	const { name, form, schema, fullplaceholder, value } = field;
	const { min, max, step } = getSource(NumberSchema, schema);
	return (
		<Field {...field}>
			<RangeInput //
				name={name}
				required={!(schema instanceof OptionalSchema)}
				min={min}
				max={max}
				step={step ?? undefined}
				placeholder={fullplaceholder}
				onValue={num => form.publish(name, num)}
				value={getOptionalNumber(value)}
			/>
			<FieldNotice name={name} />
		</Field>
	);
}

export function RangeInput({
	mods = "",
	value,
	placeholder,
	onValue,
	...props
}: {
	mods?: string | undefined;
	name?: string | undefined;
	min: number;
	max: number;
	step?: number | undefined;
	placeholder?: string | undefined;
	required?: boolean;
	value?: number | undefined;
	onValue: ValueCallback<number>;
}) {
	const onChange: FormEventHandler<HTMLInputElement> = ({ currentTarget }) => onValue(getNumber(currentTarget.value));
	return (
		<input //
			{...props}
			type="range"
			className={`input ${mods}`}
			placeholder={placeholder}
			defaultValue={value ?? undefined}
			onInput={onChange}
			onChange={onChange}
		/>
	);
}
